module.exports = __webpack_public_path__ + "img/img1.eed82f6c.png";